import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { UserStatusCheckerService } from './services/user-status-checker.service';

@Injectable({ providedIn: 'root' })
export class isUserActiveStatusGuard implements CanActivate, CanActivateChild {

  constructor(
    private authService: AuthService,
    private userStatusChecker: UserStatusCheckerService
  ) {}

  canActivate(): Promise<boolean> {
    return this.runCheck();
  }

  canActivateChild(): Promise<boolean> {
    return this.runCheck();
  }

  private runCheck(): Promise<boolean> {
    if (!this.authService.isLoggedIn()) {
      return Promise.resolve(true);
    }
    return this.userStatusChecker.checkStatus()
  }
}
